/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/pipeline.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ApiGetTemplateResponse
 */
export interface ApiGetTemplateResponse {
  /**
   * The template of the pipeline specified in a GetTemplate request, or of a
   * pipeline version specified in a GetPipelinesVersionTemplate request.
   * @type {string}
   * @memberof ApiGetTemplateResponse
   */
  template?: string;
}

/**
 * Check if a given object implements the ApiGetTemplateResponse interface.
 */
export function instanceOfApiGetTemplateResponse(value: object): value is ApiGetTemplateResponse {
  return true;
}

export function ApiGetTemplateResponseFromJSON(json: any): ApiGetTemplateResponse {
  return ApiGetTemplateResponseFromJSONTyped(json, false);
}

export function ApiGetTemplateResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiGetTemplateResponse {
  if (json == null) {
    return json;
  }
  return {
    template: json['template'] == null ? undefined : json['template'],
  };
}

export function ApiGetTemplateResponseToJSON(json: any): ApiGetTemplateResponse {
  return ApiGetTemplateResponseToJSONTyped(json, false);
}

export function ApiGetTemplateResponseToJSONTyped(
  value?: ApiGetTemplateResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    template: value['template'],
  };
}
